// removed by extract-text-webpack-plugin
module.exports = {"container":"_1TR_TWU6xHhPnnHBEWjWg0","inner":"_1W7lQz99rUeTVolUWOjMwz","loaderContainer":"_2g17nU4ElSgxF39yUlHrUj","title":"OXF82PqTFLq4uxhuLuj-R","text":"_2JaWfaDMtYkrAbVvaEGyRp","highlight":"_2ceg5gMTxSJ3TwdhkA5-Zs"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Notice/styles.css
// module id = 387
// module chunks = 0